import styled from 'styled-components';
import { P } from '../../theme/tokens';

export const Muted = styled.div`
  color: ${P.muted};
  font-size: ${({ $xs }) => ($xs ? 12 : 13)}px;
  font-weight: ${({ $b }) => ($b ? 600 : 400)};
`;

export const Row = styled.div`
  display: flex;
  align-items: ${({ $top }) => ($top ? 'flex-start' : 'center')};
  gap: ${({ $gap = 8 }) => $gap}px;
  flex-wrap: ${({ $nowrap }) => ($nowrap ? 'nowrap' : 'wrap')};
  justify-content: ${({ $between }) => ($between ? 'space-between' : 'flex-start')};
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = 8 }) => $gap}px;
  min-width: 0;
`;

export const Sm = styled.div`
  font-size: 13px;
`;

export const Xs = styled.div`
  font-size: 12px;
  color: ${({ $muted }) => ($muted ? P.muted : 'inherit')};
`;

export const SubCard = styled.div`
  background: ${P.bgSubtle};
  border-radius: 12px;
  border: 1px solid ${P.line};
  padding: ${({ $pad = 20 }) => $pad}px;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = 0 }) => $gap}px;
`;

export const Radio = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  min-height: 48px;
  input {
    width: 20px;
    height: 20px;
  }
`;
